import React, { ReactElement, useEffect, useState } from 'react';
import { VStack, Accordion } from '@chakra-ui/react';
import { NavigationLinkProps, PanelLink } from 'types/NavigationBarDesktop';
import { NavigationLink } from './NavigationLink';
import { Panel } from './DropdownPanel';

type NavigationLinkWithDropdownProps = NavigationLinkProps & {
  panelLinks: PanelLink[];
};

export const NavigationLinkWithDropdown = ({
  to,
  iconInactive,
  iconActive,
  isActive,
  title,
  panelLinks,
  hasTitle,
  onClick,
}: NavigationLinkWithDropdownProps): ReactElement => {
  const [expandedItems, setExpandedItems] = useState<string[]>(isActive ? ['nav-group'] : []);

  useEffect(() => {
    if (isActive) {
      setExpandedItems(['nav-group']);
    }
  }, [isActive]);

  return (
    <Accordion.Root
      collapsible
      value={expandedItems}
      onValueChange={(details) => setExpandedItems(details.value)}
    >
      <Accordion.Item value="nav-group" border="none">
        <Accordion.ItemTrigger p="0">
          <NavigationLink
            to={to}
            iconInactive={iconInactive}
            iconActive={iconActive}
            isActive={isActive}
            title={title}
            onClick={onClick}
            hasTitle={hasTitle}
          />
          {hasTitle && <Accordion.ItemIndicator boxSize="18px" />}
        </Accordion.ItemTrigger>
        {hasTitle && (
          <Accordion.ItemContent pt="24px">
            <VStack align="left" gap="12px" ml="36px">
              {panelLinks.map(({ to, title, isExternal }: PanelLink) => (
                <Panel to={to} title={title} isExternal={isExternal} key={title} />
              ))}
            </VStack>
          </Accordion.ItemContent>
        )}
      </Accordion.Item>
    </Accordion.Root>
  );
};
